import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaw, faWalking, faTaxi } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import { routes } from "../../config/utility";

const QuickServices = () => {
  const [hovered, setHovered] = useState(null);

  const services = [
    {
      label: "Book a Walk",
      icon: faWalking,
      bg: "bg-gradient-to-l from-secondary to-light text-tblue",
      description: "Give your pet the exercise they deserve with our trusted walkers!",
      link: routes.walk,
      buttonLabel: "Book a Walk",
    },
    {
      label: "Book a Taxi",
      icon: faTaxi,
      bg: "bg-gradient-to-r from-secondary to-secondary text-tblue",
      description: "Need a ride for your pet? We provide safe transport to and from any location!",
      link: routes.delivery,
      buttonLabel: "Book a Taxi",
    },
    {
      label: "Add New Pet",
      icon: faPaw,
      bg: "bg-gradient-to-r from-secondary to-light text-tblue",
      description: "Keep your pet profile updated to access exclusive services tailored to their needs.",
      link: routes.pet,
      buttonLabel: "Add Pet Profile",
    },
  ];

  return (
    <div className="text-center space-y-8 relative">
      <h3 className="text-3xl font-bold text-tblue my-6">Our Services</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {services.map((service, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: idx * 0.2 }}
            onMouseEnter={() => setHovered(idx)}
            onMouseLeave={() => setHovered(null)}
            className={`relative overflow-hidden rounded-lg shadow-lg transform transition-transform duration-300 hover:scale-105 ${service.bg}`}
          >
            {/* Icon and Title */}
            <div className="p-6 flex flex-col items-center text-tblue">
              <FontAwesomeIcon icon={service.icon} className="text-5xl mb-4" />
              <h4 className="text-2xl font-semibold mb-2">{service.label}</h4>
              <p className="text-sm opacity-80">{service.description}</p>
            </div>
            
            {/* Overlay and Button */}
            {hovered === idx && (
              <motion.div 
                className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 p-4"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
              >
                <Link 
                  to={service.link} // Use `to` for internal routing
                  className="bg-white text-tblue px-6 py-2 font-semibold rounded-full shadow-lg hover:bg-light hover:text-primary transition"
                >
                  {service.buttonLabel}
                </Link>
              </motion.div>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default QuickServices;
